import { Dialog, IconButton, makeStyles, Button } from "@material-ui/core";
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { SERVER_URL } from "../../../api";
import "../../../customStyles/image_carousel.css";
import {
  downloadFilesAsZip,
  getFileIconByExtension,
  getFileType,
} from "../../../utils/helpers";
import PreviewDialog from "../dialogs/PreviewDialog";
import {
  CloudDownload,
  CloudUpload,
  Description,
  PictureAsPdf,
  GetApp,
  OpenInNew,
} from "@material-ui/icons";
import ImageCarouselDialog from "../dialogs/ImageCarouselDialog";

const useStyles = makeStyles(() => ({
  media: {
    display: "block",
    width: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
    objectPosition: "left",
    // objectPosition: "center",
    // margin: "auto",
  },
  dialogContent: {
    padding: 30,
    overflow: "hidden",
  },
  fileContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  fileIconContainer: {
    width: "50%",
    height: "200px",
    border: "1px solid #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
    backgroundColor: "#f9f9f9",
  },
  fileIcon: {
    fontSize: "4rem",
    color: "#666",
  },
  imageContainer: {
    width: "100%",
    maxHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
  },
  pdfContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  pdfEmbed: {
    width: "100%",
    height: "300px",
    marginBottom: "16px",
  },
  actionButton: {
    margin: "8px",
    backgroundColor: "#000000",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#333333",
    },
  },
}));

function ordenarLista(lista) {
  const listaOrdenada = [...lista].sort((a, b) => a.order - b.order);
  const listaUrl = listaOrdenada?.map((x) => x.url);
  return listaUrl;
}

const MyCarousel = ({
  lista,
  isDownload = true,
  handleOpenUpload,
  nameFile,
  carruselDocs = false,
}) => {
  const classes = useStyles();
  const images = ordenarLista(lista);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImage, setPreviewImages] = useState(null);

  const settings = {
    infinite: images?.length > 1,
    speed: 500,
    slidesToShow: Math.min(images.length, 4),
    slidesToScroll: 4,
    arrows: true,
  };

  const isVideo = (url) => {
    return url
      ? typeof url === "object"
        ? url?.name?.toLowerCase().endsWith(".mp4") ||
          url?.name?.toLowerCase().endsWith(".webm") ||
          url?.name?.toLowerCase().endsWith(".ogg")
        : url?.toLowerCase().endsWith(".mp4") ||
          url?.toLowerCase().endsWith(".webm") ||
          url?.toLowerCase().endsWith(".ogg")
      : false;
  };

  const type = (url) => {
    const type = typeof url === "string" ? url : url.name;
    return getFileType(type);
  };

  const getMediaSrc = (media) => {
    return typeof media === "string"
      ? `${SERVER_URL}/${media}`
      : URL.createObjectURL(media);
  };

  const getFileName = (media) => {
    return typeof media === "string" ? media.split("/").pop() : media.name;
  };

  const downloadFile = (media, forceDownload = false) => {
    const mediaSrc = getMediaSrc(media);
    const fileName = getFileName(media);

    if (forceDownload && typeof media === "string") {
      // Para imágenes del servidor, usar fetch para forzar descarga
      fetch(mediaSrc)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error downloading file:", err));
    } else {
      const link = document.createElement("a");
      link.href = mediaSrc;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const renderFileContent = (media, index) => {
    const fileType = type(media);
    const fileName = getFileName(media);
    const mediaSrc = getMediaSrc(media);

    if (fileName.toLowerCase().includes(".pdf")) {
      return (
        <div className={classes.pdfContainer}>
          <embed
            src={mediaSrc + "#zoom=50,150"}
            className={classes.pdfEmbed}
            type="application/pdf"
          />
          <Button
            variant="contained"
            startIcon={<OpenInNew />}
            className={classes.actionButton}
            onClick={() => window.open(mediaSrc, "_blank")}
          >
            Abrir {fileName}
          </Button>
        </div>
      );
    } else {
      // Para archivos Word y otros tipos
      return (
        <div className={classes.fileContainer}>
          <div className={classes.fileIconContainer}>
            <div className={classes.fileIcon}>
              {getFileIconByExtension(fileName)}
            </div>
          </div>
          <Button
            variant="contained"
            startIcon={<GetApp />}
            className={classes.actionButton}
            onClick={() => downloadFile(media)}
          >
            Descargar
          </Button>
        </div>
      );
    }
  };

  const renderImageAsDoc = (media, index) => {
    const mediaSrc = getMediaSrc(media);

    return (
      <div className={classes.fileContainer}>
        <div className={classes.imageContainer}>
          <img
            src={mediaSrc}
            alt={`Document Image ${index}`}
            className={classes.media}
            onClick={() => {
              const imageUrl = getMediaSrc(media);
              window.open(imageUrl, "_blank");
            }}
          />
        </div>
        <Button
          variant="contained"
          startIcon={<GetApp />}
          className={classes.actionButton}
          onClick={() => downloadFile(media, true)}
        >
          Descargar
        </Button>
      </div>
    );
  };

  return (
    <>
      <section
        className="d-flex flex-row justify-content-end"
        style={{ marginRight: "50px" }}
      >
        {isDownload && (
          <IconButton
            onClick={() => downloadFilesAsZip(images, nameFile)}
            aria-label="Download media"
          >
            <CloudDownload />
          </IconButton>
        )}
        {handleOpenUpload && (
          <IconButton onClick={handleOpenUpload} aria-label="Download media">
            <CloudUpload />
          </IconButton>
        )}
      </section>
      <div className="my-slider-container slick-slider">
        <Slider {...settings}>
          {images?.map((media, index) => (
            <div key={index} className="my-slick-slide">
              {isVideo(media) ? (
                <video
                  controls
                  className={classes.media}
                  src={getMediaSrc(media)}
                />
              ) : type(media) === "image" ? (
                carruselDocs ? (
                  renderImageAsDoc(media, index)
                ) : (
                  <img
                    src={getMediaSrc(media)}
                    alt={`Artwork Media ${index}`}
                    className={classes.media}
                    onClick={() => {
                      setPreviewImages(getMediaSrc(media));
                      setOpenPreviewDialog(2);
                    }}
                  />
                )
              ) : (
                renderFileContent(media, index)
              )}
            </div>
          ))}
        </Slider>
        <ImageCarouselDialog
          open={openPreviewDialog === 2}
          setOpen={setOpenPreviewDialog}
          images={images ?? []}
        />
      </div>
    </>
  );
};

export default MyCarousel;
